export const getEnemyCitiesForPlayer = (playerColor, citiesCache) => {
  return Object.entries(citiesCache)
    .filter(([color]) => color !== playerColor)
    .flatMap(([_, cities]) => cities);
}